<div class="float-drag" cdkDrag>
	<div class="float-container" cdkDragHandle>
        <div class="float-header" >
			<div class="header-text">Boundary Wizard</div>
			<i class="glyphicons glyphicons-remove" (click)="close()"></i>
        </div>
	
		<div class="wizard-content-wrap-columns">
			<div class="wizard-step-container">
				<ng-container *ngFor="let step of steps">
					<div *ngIf="step.num <= currentStep.num" [@fadeInOut] [ngClass]="{'step-title-line': step.isSameLine}">
						<app-wizard-step-title [stepNum]="step.num" [stepLabel]="step.label" [isCurrent]="step.num===currentStep.num"></app-wizard-step-title>
						<div *ngIf="step.prop==='selectAction'" class="action-item">
							<div *ngFor="let ac of actionList" class="same-line">
								<input name="currentAction" type="radio" [disabled]="step.num!==currentStep.num" [value]="ac.prop" [(ngModel)]="currentAction" (ngModelChange)="onSelectAction()">
								<div>{{ac.label}}</div>
							</div>
						</div>
						<div *ngIf="step.prop==='isCarveout'" class="action-item">
							<div class="same-line">
								<input name="isCarveout" type="radio" [disabled]="step.num!==currentStep.num" [value]="false" [(ngModel)]="isCarveout" (ngModelChange)="onToggleCarveout()">
								<div>No</div>
							</div>
							<div class="same-line">
								<input name="isCarveout" type="radio" [disabled]="step.num!==currentStep.num" [value]="true" [(ngModel)]="isCarveout" (ngModelChange)="onToggleCarveout()">
								<div>Yes</div>
							</div>
						</div>
						<div *ngIf="step.prop==='editBdry'||step.prop==='drawNew'" class="action-item">
							<div>
								<div>Double-click on map to exit vertex mode</div>
								<div>Right-click on map to re-enter vertex mode</div>
							</div>
						</div>
						<!-- <div *ngIf="step.prop==='selectAreaType'" class="action-item">
							<div *ngFor="let areaType of areaTypeList" class="same-line">
								<input name="currentAreaType" type="radio" [value]="areaType.type" [(ngModel)]="currentAreaType" (ngModelChange)="onSelectAreaType()">
								<div>{{areaType.label}}</div>
							</div>
						</div> -->
					</div>
				</ng-container>
			</div>
	
			<div class="wizard-button-groups">
				<div style="flex-grow:1;margin-bottom: 10px;">
					<button class="button-general button-small" (click)="cancel()">Cancel</button>
				</div>
				<button class="button-general button-small" [disabled]="checkAddCardsDisabled(currentStep.prop)" (click)="addCards()">Add Cards</button>
			</div>
		</div>
	</div>
</div>